export const actions = {
    ADD_LOCATION_CARDS: 'ADD_LOCATION_CARDS',
    CLOSE_LOCATION_CARDS: 'CLOSE_LOCATION_CARDS',
    LOAD_NOTIFICATION: 'LOAD_NOTIFICATION',
    LOAD_USER: 'LOAD_USER'
};